export default "__VITE_ASSET__Buh0XaL1__"